import channelsStore from "@/app/channels/store/channels";

export default {
  modules: {
    channelsStore,
  },
};
